export interface ISpeculationRule {
  enabled: boolean;
  page_url_regexp: string;
  whitelist_path_patterns: string[];
  blacklist_path_patterns: string[];
}

class SpeculationRule {
  public readonly enabled: boolean;
  public readonly pageUrlRegexp: string;
  public readonly whitelistPathPatterns: string[];
  public readonly blacklistPathPatterns: string[];

  constructor({
    enabled,
    pageUrlRegexp,
    whitelistPathPatterns,
    blacklistPathPatterns,
  }: {
    enabled: boolean;
    pageUrlRegexp: string;
    whitelistPathPatterns: string[];
    blacklistPathPatterns: string[];
  }) {
    this.enabled = enabled;
    this.pageUrlRegexp = pageUrlRegexp;
    this.whitelistPathPatterns = whitelistPathPatterns;
    this.blacklistPathPatterns = blacklistPathPatterns;
  }

  public static fromAPI = (data: ISpeculationRule): SpeculationRule => {
    return new SpeculationRule({
      enabled: data.enabled,
      pageUrlRegexp: data.page_url_regexp,
      whitelistPathPatterns: data.whitelist_path_patterns,
      blacklistPathPatterns: data.blacklist_path_patterns,
    });
  };

  public toAPI = () => ({
    enabled: this.enabled,
    page_url_regexp: this.pageUrlRegexp,
    whitelist_path_patterns: this.whitelistPathPatterns,
    blacklist_path_patterns: this.blacklistPathPatterns,
  });
}

export default SpeculationRule;
